import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MobileBottomBar = _resolveComponent("MobileBottomBar")!

  return (_openBlock(), _createBlock(_component_MobileBottomBar, { id: "mobile-nav" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: link.to,
          to: link.to,
          class: "mobile-bottom-bar-item",
          onClick: _ctx.linkClick,
          replace: "",
          "exact-path": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), { size: 22 })),
            _createElementVNode("span", _hoisted_1, _toDisplayString(link.text), 1)
          ]),
          _: 2
        }, 1032, ["to", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}